// apps/web/src/services/PrizeConfigurationsService.js

import fetch from 'auth/FetchInterceptor'

const buildQueryString = (params = {}) => {
  const query = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      value !== ''
    ) {
      query.append(key, String(value))
    }
  })

  const queryString = query.toString()

  return queryString ? `?${queryString}` : ''
}

const unwrapResponse = (response) => {
  return response?.data || response
}

const normalizeList = (response) => {
  const data = unwrapResponse(response)

  if (Array.isArray(data)) {
    return data
  }

  if (Array.isArray(data?.items)) {
    return data.items
  }

  return []
}

const PrizeConfigurationsService = {
  async getGames() {
    const response = await fetch({
      url: '/games',
      method: 'get',
    })

    return normalizeList(response)
  },

  async getPrizesByGame(gameId) {
    const response = await fetch({
      url: `/prizes${buildQueryString({
        gameId,
      })}`,
      method: 'get',
    })

    return normalizeList(response)
  },

  async getConfigurations(prizeId) {
    const response = await fetch({
      url: `/prizes/${prizeId}/configurations`,
      method: 'get',
    })

    return normalizeList(response)
  },

  async getEffectiveConfiguration(prizeId, date) {
    const response = await fetch({
      url: `/prizes/${prizeId}/configurations/effective${buildQueryString(
        {
          date,
        },
      )}`,
      method: 'get',
    })

    return unwrapResponse(response)
  },

  async getConfiguration(configurationId) {
    const response = await fetch({
      url: `/prizes/configurations/${configurationId}`,
      method: 'get',
    })

    return unwrapResponse(response)
  },

  async createConfiguration(prizeId, data) {
    const response = await fetch({
      url: `/prizes/${prizeId}/configurations`,
      method: 'post',
      data: {
        date: data.date,
        enabled: data.enabled ?? true,

        dailyLimit:
          data.dailyLimit === undefined ||
          data.dailyLimit === null ||
          data.dailyLimit === ''
            ? null
            : Number(data.dailyLimit),

        probabilityWeight:
          data.probabilityWeight === undefined ||
          data.probabilityWeight === null ||
          data.probabilityWeight === ''
            ? null
            : Number(data.probabilityWeight),

        notes: data.notes || null,
      },
    })

    return unwrapResponse(response)
  },

  async updateConfiguration(configurationId, data) {
    const response = await fetch({
      url: `/prizes/configurations/${configurationId}`,
      method: 'patch',
      data: {
        date: data.date,
        enabled: data.enabled ?? true,

        dailyLimit:
          data.dailyLimit === undefined ||
          data.dailyLimit === null ||
          data.dailyLimit === ''
            ? null
            : Number(data.dailyLimit),

        probabilityWeight:
          data.probabilityWeight === undefined ||
          data.probabilityWeight === null ||
          data.probabilityWeight === ''
            ? null
            : Number(data.probabilityWeight),

        notes: data.notes || null,
      },
    })

    return unwrapResponse(response)
  },

  async deleteConfiguration(configurationId) {
    const response = await fetch({
      url: `/prizes/configurations/${configurationId}`,
      method: 'delete',
    })

    return unwrapResponse(response)
  },
}

export default PrizeConfigurationsService